"use client";

import { useEffect, useState } from "react";
import Link from "next/link";

// A plain NOTICE, not an accept/reject-by-category consent manager -- every cookie this site sets itself
// is strictly necessary (sign-in, cart persistence; see /legal/cookies), and strictly-necessary cookies
// don't need opt-in consent under the frameworks that require one. There's nothing non-essential to let a
// shopper turn off, so a granular picker would be UI for a decision that doesn't exist yet -- add one if
// that ever changes (e.g. analytics gets added), not before.
const DISMISSED_KEY = "cruxdigital_cookie_notice_dismissed";

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- reading a client-only localStorage flag, same tradeoff as this codebase's other post-mount reveal checks
    setVisible(!window.localStorage.getItem(DISMISSED_KEY));
  }, []);

  const dismiss = () => {
    window.localStorage.setItem(DISMISSED_KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="region" aria-label="Cookie notice">
      <p>
        We use a few strictly-necessary cookies to keep you signed in and remember your cart — nothing
        else. See our <Link href="/legal/cookies">Cookie Policy</Link> for exactly what and why.
      </p>
      <div className="cookie-banner-actions">
        <button type="button" className="primary" onClick={dismiss}>
          Got it
        </button>
      </div>
    </div>
  );
}
